export function updateVerificationStatus(data) {
    return (dispatch) => {
        dispatch({
            type: 'UPDATE_VERIFICATION_STATUS',
            payload: data
        });
    }
}